import { useRef, useState } from 'react';
import { Button } from './ui/button';
import { PhotoIcon, CameraIcon, Spinner } from './icons';

function FileButton({
  icon,
  label,
  accept,
  capture,
  loading,
  onFile,
}: {
  icon: React.ReactNode;
  label: string;
  accept: string;
  capture?: 'user' | 'environment';
  loading: boolean;
  onFile: (file: File) => void;
}) {
  const ref = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) onFile(file);
    e.target.value = '';
  };

  return (
    <Button
      variant="default"
      className="w-full justify-start"
      disabled={loading}
      onClick={() => ref.current?.click()}
    >
      {loading ? <Spinner /> : icon}
      {label}
      <input
        ref={ref}
        type="file"
        accept={accept}
        capture={capture}
        onChange={handleChange}
        className="hidden"
      />
    </Button>
  );
}

export function UploadButtons({ onFile }: { onFile: (file: File) => Promise<void> | void }) {
  const [loading, setLoading] = useState(false);

  const handleFile = async (file: File) => {
    setLoading(true);
    try {
      await onFile(file);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <FileButton icon={<CameraIcon />} label="Prendre une photo" accept="image/*" capture="environment" loading={loading} onFile={handleFile} />
      <FileButton icon={<PhotoIcon />} label="Choisir une image ou un PDF" accept="image/*,.pdf,application/pdf" loading={loading} onFile={handleFile} />
    </div>
  );
}
